import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../contexts/PermissionsContext';

/**
 * Component that redirects /admin to the first available admin tab based on user permissions
 */
const AdminRedirect: React.FC = () => {
  const { user } = useAuth();
  const { hasPermission, loading: permissionsLoading } = usePermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || permissionsLoading) {
      return;
    }

    // Super Admin can access everything, default to users (first tab)
    if (user.role_id === 1) {
      navigate('/admin/users', { replace: true });
      return;
    }

    // Check permissions in order (matching the permission list order)
    // and redirect to first available tab
    if (hasPermission('admin.user_management')) {
      navigate('/admin/users', { replace: true });
      return;
    }

    if (hasPermission('admin.audit_logs')) {
      navigate('/admin/audit', { replace: true });
      return;
    }

    if (hasPermission('admin.production_schedule')) {
      navigate('/admin/schedule', { replace: true });
      return;
    }

    // If no permissions, redirect to users (will show access denied)
    navigate('/admin/users', { replace: true });
  }, [user, hasPermission, permissionsLoading, navigate]);

  return null;
};

export default AdminRedirect;
